import {Pipe, PipeTransform} from '@angular/core';
import {hasPermissionForAttachment} from './attachments.util';
import {environment} from '../../../environments/environment';

@Pipe({
  name: 'userGroupsFilter',
  standalone: true
})
export class UserGroupsFilterPipe implements PipeTransform {
  transform(attachments = [], userGroups: string[], isProSpace = false): any {
    if (environment.NOUI) {
      return attachments;
    }

    if (!isProSpace) {
      return attachments;
    }

    return attachments.filter(attachment => hasPermissionForAttachment(attachment, userGroups));
  }
}
